(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/dialogs.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/dialogs.js');

'use strict';

const isPnp = svs.core.config.data.svsconfig.site === 'momang';
const mobileConfirmedSuccessTitle = "Mobilnummer bekr\xE4ftat!";
const mobileConfirmedSuccessMessage = 'Nytt mobilnummer: ';
const queryUrl = svs.utils.url.queryString.returnUrl;
const returnUrl = queryUrl ? svs.utils.url.makeInternal(queryUrl) : undefined;
const showSettingsTechnicalError = function () {
  let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'För tillfället upplever vi tekniska problem. Alla inställningar är inte tillgängliga just nu. Vänligen försök igen senare.';
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    type: svs.ui.dialog.type.ERROR,
    title: 'Tekniskt fel',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showNotLoggedInError = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    type: svs.ui.dialog.type.ERROR,
    title: 'Du är inte inloggad',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Vänligen logga in och försök igen'
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        svs.core.userSession.logout();
        svs.utils.url.navigate("".concat(svs.core.urlMapping.get('loginHome'), "?returnUrl=").concat(svs.utils.url.currentPathEncodedParams()));
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showCustomersOldLinkError = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: 'Tekniskt fel',
    type: svs.ui.dialog.type.ERROR,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Du har använt en gammal eller felaktig länk. Logga in för att ändra dina kommunikationsval.'
    }],
    actions: [{
      title: 'Okej',
      callback() {
        svs.utils.url.navigate("".concat(svs.core.urlMapping.get('loginHome'), "?returnUrl=").concat(svs.utils.url.currentPathEncodedParams()));
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showBaseError = function (title, text) {
  let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    type: svs.ui.dialog.type.ERROR,
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        callback();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showTechnicalError = function () {
  let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'För tillfället upplever vi tekniska problem. Vänligen försök igen senare.';
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  showBaseError('Tekniskt fel', text, callback);
};
const showHandledError = function (text) {
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  showBaseError('Ett fel har uppstått', text, callback);
};
const showMobileConfirmedFlash = mobile => {
  svs.core.flash(svs.ui.dialog.type.SUCCESS, {
    title: mobileConfirmedSuccessTitle,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: mobileConfirmedSuccessMessage + mobile
    }],
    branding: isPnp ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT,
    area: svs.ui.dialog.area.POPUP,
    icon: 'thumbs-up'
  });
};
const showMobileConfirmedDialog = (mobile, callback) => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'thumbs-up',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: mobileConfirmedSuccessTitle,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: mobileConfirmedSuccessMessage + mobile
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        callback();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showMobileVerificationCodeSent = mobile => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'checkmark',
    autoClose: svs.ui.dialog.autoClose.MEDIUM,
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: "SMS med bekr\xE4ftelsekod har skickats till: ".concat(mobile),
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showOrderTranscriptError = text => {
  const dialog = new svs.ui.dialog.Confirm({
    title: 'Ett problem har uppstått',
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    type: svs.ui.dialog.type.ERROR,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: text || 'Ett fel har inträffat vid beställning av utdrag. Försök igen lite senare och om felet kvarstår, kontakta Kundservice.'
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showAboutTranscript = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'document',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: "Om registerutdrag",
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: "Enligt dataskyddsf\xF6rordningens artikel 15 har du r\xE4tt att f\xE5 information om bland annat vilka personuppgifter som f\xF6r n\xE4rvarande behandlas \n        om dig som kund samt \xE4ndam\xE5len med behandlingen."
    }, {
      type: svs.ui.dialog.message.TEXT,
      text: "Vill du l\xE4sa mer om hur vi behandlar dina personuppgifter se <a href=".concat(svs.core.urlMapping.get('termsIntegrityPersonData'), ">\n        AB Svenska Spels information om behandling av personuppgifter.</a>")
    }],
    actions: [{
      title: 'Stäng',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const confirmRemovePauseDialog = callback => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: 'Vill du ta bort din paus av notiser?',
    actions: [{
      title: 'Avbryt',
      callback: () => {
        dialog.close();
      }
    }, {
      title: 'Ta bort paus',
      callback: () => {
        dialog.close();
        callback();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const pauseRemovedDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'thumbs-up',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: 'Din paus av notiser är borttagen!',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Du kommer nu åter att kunna få notiser från dina spel.'
    }],
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const pauseAddedDialog = (time, untilNextDay) => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'thumbs-up',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: 'Dina notiser har pausats',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: untilNextDay ? 'Notiser kommer åter börja skickas klockan 08.00 imorgon' : "Notiser kommer \xE5ter b\xF6rja skickas klockan ".concat(dateFns.format(new Date(time), 'HH:mm'))
    }],
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const missingEmailDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: 'Din e-postadress har tagits bort',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Adressen har tagits bort eftersom den inte bekräftades eller användes av flera kunder. Fyll i och bekräfta en e-postadress.'
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const aliasAddedDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'thumbs-up',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: 'Alias sparat',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Ditt alias är nu sparat'
    }],
    actions: [{
      title: 'Okej',
      callback() {
        returnUrl && svs.utils.url.navigate(returnUrl);
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
svs.myProfile.react.shared.dialogs = {
  showCustomersOldLinkError,
  showSettingsTechnicalError,
  showNotLoggedInError,
  showTechnicalError,
  showMobileConfirmedFlash,
  showMobileConfirmedDialog,
  showMobileVerificationCodeSent,
  showHandledError,
  showBaseError,
  showOrderTranscriptError,
  showAboutTranscript,
  confirmRemovePauseDialog,
  pauseRemovedDialog,
  pauseAddedDialog,
  aliasAddedDialog,
  missingEmailDialog
};

 })(window);